// Module
var code = "<react-component name=\"ManageWebsiteMobileAppAccess\" ng-if=\"mobileAppSettings\" props=\"{mobileAppSettingsData: mobileAppSettings, onMobileAppSettingsSave: setMobileAppSettings}\"></react-component>\n";
// Exports
module.exports = code;